import { render } from "./AllProducts.vue?vue&type=template&id=d4eb1db4&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"

import "./AllProducts.vue?vue&type=style&index=0&id=d4eb1db4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4eb1db4"]])

export default __exports__